import numeral from 'numeral'

// Set Number/String to number
// return Number
function toNum() {
  return parseFloat(this.valueOf().toString().replace(/[^\d\.]/g, ''), 10) || 0;
}

Number.prototype.toNum = toNum;
String.prototype.toNum = toNum;


// Add commas to Number/String numbers
// return String
function withCommas() {
  return numeral(this.valueOf()).format('0,0');
}

Number.prototype.withCommas = withCommas;
String.prototype.withCommas = withCommas;


// Number/String to price format
// return String
function toPrice() {
  return numeral(this.valueOf()).format('0,0.00');
}

Number.prototype.toPrice = toPrice;
String.prototype.toPrice = toPrice;

// Check `event` if is the number key
// return Boolean
window.onlyNumberKey = function onlyNumberKey(e) {
  const charCode  = (e.which) ? e.which : e.keyCode;
  const maxLength = this && this.toNum ? this.toNum() : 10;

  if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  return e.target.value.length <= maxLength;
}



// WEBPACK FOOTER //
// app/javascript/common/utils.js